export default "__VITE_ASSET__CVYNXb5R__"